import Vue from 'vue';
import { HotelDetailsBreadcrumb } from "../HotelDetailsBreadcrumb/hotel-details-breadcrumb";
var initializeHotelDetailsBreadcrumb = function () {
    new Vue({
        render: function (h) { return h(HotelDetailsBreadcrumb); },
    }).$mount('#hotel-details-breadcrumb');
};
export default initializeHotelDetailsBreadcrumb;
